
import Barcode from "vue-barcode";
export default {
  name: "GiftCardBarcode",
  components: {
    Barcode,
  },
  props: {
    item: {
      type: Object,
      default: false,
    },
  },
  computed: {
    giftCardAmount() {
      if (this.item.restAmount == this.item.originalAmount) {
        return "Kr " + this.formatAmount(this.item.originalAmount, 2);
      } else {
        return (
          "Kr " +
          this.formatAmount(this.item.restAmount, 1) +
          " (av " +
          this.formatAmount(this.item.originalAmount, 2) +
          ")"
        );
      }
    },
  },
  methods: {
    formatAmount(value, format) {
      if (value % 1 == 0 && format == 1) {
        return value + ", –";
      } else if (value % 1 == 0 && format == 2) {
        return value;
      } else {
        return value.toFixed(2).replace(".", ",");
      }
    },
  },
};
